module.exports = __webpack_public_path__ + "static/media/icon-general.bbfc04d4.svg";